import { render, staticRenderFns } from "./chetouList.vue?vue&type=template&id=0106ff46&"
import script from "./chetouList.vue?vue&type=script&lang=js&"
export * from "./chetouList.vue?vue&type=script&lang=js&"
import style0 from "./chetouList.vue?vue&type=style&index=0&id=0106ff46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports